var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMainDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 24.0001H14.25C14.6642 24.0001 15 23.6643 15 23.25C15 22.8358 14.6642 22.5 14.25 22.5H4.5C3.94772 22.5 3.5 22.0523 3.5 21.5V2.5C3.5 1.94772 3.94772 1.5 4.5 1.5H16.5C17.0523 1.5 17.5 1.94772 17.5 2.5V11.25C17.5 11.6642 17.8358 12 18.25 12C18.6642 12 19 11.6642 19 11.25V2C19 0.895431 18.1046 0 17 0H4C2.89543 0 2 0.895431 2 2V22.0001C2 23.1046 2.89543 24.0001 4 24.0001Z",
    fill: "#0B264F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 15.4999C8.99999 15.7762 8.77615 16 8.49991 16C8.22384 16 8 15.7762 8 15.4999C8 15.2238 8.22384 15 8.49991 15C8.77615 15 8.99999 15.2238 8.99999 15.4999Z",
    fill: "#0B264F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 15.4999C11.0002 15.7762 10.7762 16 10.5001 16C10.224 16 10 15.7762 10 15.4999C10 15.2238 10.224 15 10.5001 15C10.7762 15 11.0002 15.2238 11.0002 15.4999Z",
    fill: "#0B264F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.4999C13 15.7762 12.7762 16 12.5001 16C12.2238 16 12 15.7762 12 15.4999C12 15.2238 12.2238 15 12.5001 15C12.7762 15 13 15.2238 13 15.4999Z",
    fill: "#0B264F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5H7.5C6.94772 12.5 6.5 12.0523 6.5 11.5V5.5C6.5 4.94772 6.94772 4.5 7.5 4.5H13.5C14.0523 4.5 14.5 4.94772 14.5 5.5V11.5C14.5 12.0523 14.0523 12.5 13.5 12.5H13",
    stroke: "#0B264F",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.745L19.2595 20.745L19.077 20.9015L16.6496 22.9823L16.6467 13.253L22.6467 20.745L19.5 20.745Z",
    stroke: "#0B264F",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H14.5C14.7761 19 15 19.2239 15 19.5V19.5C15 19.7761 14.7761 20 14.5 20H3V19Z",
    fill: "#0B264F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainDrive);
export default __webpack_public_path__ + "static/media/icon_main_drive.ae7e43dd0a229ac2351c8c53cec13126.svg";
export { ForwardRef as ReactComponent };